module.exports = __webpack_public_path__ + "static/media/nayomi.0906579d.jpg";